(function () {
  'use strict';

  var IMPRESSION_THRESHOLD = 0.5;
  var impressed = new WeakSet();

  function getDetail(el) {
    return {
      type: el.getAttribute('data-cro-type') || '',
      surface: el.getAttribute('data-cro-surface') || '',
      variant: el.getAttribute('data-cro-variant') || 'default'
    };
  }

  function fireImpression(el) {
    if (impressed.has(el)) return;
    impressed.add(el);
    document.dispatchEvent(new CustomEvent('cro:impression', { detail: getDetail(el) }));
  }

  function observeImpressions() {
    if (typeof IntersectionObserver === 'undefined') return;

    var observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i += 1) {
        if (entries[i].isIntersecting) {
          fireImpression(entries[i].target);
          observer.unobserve(entries[i].target);
        }
      }
    }, { threshold: IMPRESSION_THRESHOLD });

    function observeAll() {
      var elements = document.querySelectorAll('[data-cro-type]');
      for (var j = 0; j < elements.length; j += 1) {
        if (!impressed.has(elements[j])) {
          observer.observe(elements[j]);
        }
      }
    }

    observeAll();

    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(function () {
        observeAll();
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  function listenInteractions() {
    document.addEventListener('click', function (event) {
      var el = event.target.closest('[data-cro-type]');
      if (!el) return;
      document.dispatchEvent(new CustomEvent('cro:interaction', { detail: getDetail(el) }));
    });
  }

  /*
   * Quiz (Octane Style Finder) event family — theme-owned contract.
   * Emitted by assets/octane-quiz.js on the document as `rr:quiz.*`. This
   * bridge normalizes them into the unified `cro:quiz` event for downstream
   * consumers (Klaviyo, GA, etc.).
   *
   * Documented payload shapes:
   *   quiz.started   { trigger, page_type }
   *   quiz.answered  { question_index, question_id, answer_tag }
   *   quiz.abandoned { last_question_index, last_question_id }
   *   quiz.completed { result_path, vibe, occasion, fit, time_to_complete_ms }
   *   quiz.opt_in    { channels, result_path }   // never carries phone/email
   */
  var QUIZ_EVENTS = [
    'quiz.started',
    'quiz.answered',
    'quiz.abandoned',
    'quiz.completed',
    'quiz.opt_in'
  ];
  var PII_KEYS = ['phone', 'phone_number', 'email', 'sms', 'tel'];

  function stripPii(detail) {
    var clean = {};
    for (var key in detail) {
      if (!Object.prototype.hasOwnProperty.call(detail, key)) continue;
      if (PII_KEYS.indexOf(key) !== -1) continue;
      clean[key] = detail[key];
    }
    return clean;
  }

  function listenQuiz() {
    for (var i = 0; i < QUIZ_EVENTS.length; i += 1) {
      (function (name) {
        document.addEventListener('rr:' + name, function (event) {
          var detail = stripPii((event && event.detail) || {});
          document.dispatchEvent(
            new CustomEvent('cro:quiz', { detail: { name: name, detail: detail } })
          );
        });
      })(QUIZ_EVENTS[i]);
    }
  }

  function init() {
    observeImpressions();
    listenInteractions();
    listenQuiz();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
